<template lang="pug">
  div
    filter-table(
      layout="text"
      @inputSearchFilter="inputSearchFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'tariff', order: 'descending'}"
        @expand-change="showTramos",
        :row-key="getRowKey"
        :expand-row-keys="expandKey"
        )
        ods-table-column(prop='numrappel' label='Código' sortable)
        ods-table-column(prop='desrappel' label='Descripción' sortable)
        ods-table-column(prop='desaplrappel' label='Aplicación' sortable)
        ods-table-column(prop='desperrap' label='Periodicidad' sortable)
        ods-table-column(type="expand")
          template(slot-scope="props")
            .tramos.moneda
              p.title.tp-m-micro Condiciones
              ods-table(
                v-if="Array.isArray(tramos) && tramos.length"
                style='width: 100%'
                :data='tramos'
                stripe
                )
                ods-table-column(prop='numlinrap' label='Nº DE CONDICIÓN')
                ods-table-column(label="%APLICACIÓN")
                  template(slot-scope="props")
                    span  {{ props.row.porlinrap }} {{ percentageSymbol }}
                ods-table-column(label='IMPORTE FACTURACIÓN')
                  template(slot-scope="props")
                    span  {{ props.row.impminrap | toCurrencyCode(props.row.clamon) }}
                ods-table-column(prop='desrappel' label="TIPO FINANCIACIÓN"
                min-width="130")
                ods-table-column(prop='destipcoco' label='TIPO DE OPERACIÓN')
                ods-table-column(prop='numminrap' label="Nº MIN. MOVIMIENTOS")
                ods-table-column(label='MIN. CUOTAS')
                  template(slot-scope="props")
                    span  {{ props.row.nummincuo }}
                ods-table-column(prop='nummaxcuo' label="MÁX. CUOTAS")
                  template(slot-scope="props")
                    span {{ props.row.nummaxcuo }}

              p.notfound(v-else)
                template(v-if="loadingAxios") {{ $t('tabTariff.loadingSections') }}
                template(v-else) {{ $t('tabTariff.notFoundSections') }}

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'RateRappelTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    // data: {
    //   required: true
    // }

    comercio: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: {
        tipoestrap: 'C',
        codcom: this.comercio.codcom
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      expandKey: [],
      // tableData: this.data,
      // itemsPerPage: 10,
      // currentPageData: 1,
      // totalData: 0,
      tramos: [],
      percentageSymbol: '%'
    }
  },

  computed: {
    ...mapGetters([
      'loadingAxios'
    ])
  },

  watch: {
    // data (newData, oldData) {
    //   this.tableData = newData
    //   this.totalData = newData.length
    // },
    tramos (val) {
      if (val) {
        console.log(val)
      }
    }
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Tarifario - Tipos de Rappel
      await this.$store.dispatch('typeRappel', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.desrappel.toLowerCase().includes(text.toLowerCase())
      })
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    goToDetail (row) {
      this.$router.push('/credits/' + row.number)
    },

    showTramos (row, other) {
      this.tramos = []
      this.expandKey = [row.numrappel]
      this.$store.dispatch('numRappel', { numrappel: this.expandKey })
        .then((res) => {
          this.tramos = res
        })
    },

    getRowKey (row) {
      return row.numrappel
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;

    &.second-table {
      margin: 0 rem(24);
    }
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
.moneda{
  .cell{
    > span{
      margin:0 2px 0 0;
    }
  }
}
</style>
